import { InvoiceStatusEnum } from "libs/shared-models/masters/src/lib/enums/invoice-status.enum"

export class InvoiceStatusReq{
    status: InvoiceStatusEnum
    grnId?:number
    indentId?:number

    constructor(status: InvoiceStatusEnum,grnId?:number,indentId?:number){
        this.status = status
        this.grnId = grnId
        this.indentId = indentId
    }
}